import React, {useState} from 'react';
import { useMediaQuery} from "@mui/material";
import {Grid,  FormControl, TextField, Button} from "@mui/material";
import "./AddressPage.scss";
import CartModal from '../cartModal/CartModal';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';


const AddressPage = () => {
  const mobileView = useMediaQuery("(max-width:920px)");
  const buttonStyle = {
    backgroundColor: "#0C5BA0",
    height: '40px',
    width: '89%', 
    marginTop: '16px', 
    marginLeft: '23px',
  };
  
  const navigate = useNavigate();
  const [isModalOpen, setModalOpen] = useState(false);
  const [promoCode, setPromoCode] = useState(
    JSON.parse(localStorage.getItem("buyer-address"))?.promoCode || ""
  );
  const [addressLine1, setAddressLine1] = useState(
    JSON.parse(localStorage.getItem("buyer-address"))?.addressLine1 || ""
  );
  const [addressLine2, setAddressLine2] = useState(
    JSON.parse(localStorage.getItem("buyer-address"))?.addressLine2 || ""
  );
  const [city, setCity] = useState(
    JSON.parse(localStorage.getItem("buyer-address"))?.city || ""
  );
  const [state, setState] = useState(
    JSON.parse(localStorage.getItem("buyer-address"))?.state || ""
  );
  const [postalCode, setPostalCode] = useState(
    JSON.parse(localStorage.getItem("buyer-address"))?.postalCode || ""
  );
  let full_name = "";
  if(localStorage.full_name) {
    full_name = localStorage.getItem("full_name");
  }

  const handleOpenModal = () => {
    setModalOpen(true); // Open the modal when this function is called
  };

  const handleCloseModal = () => {
    setModalOpen(false); // Close the modal when this function is called
  };

  const handleConfirm = (code) => {
    setPromoCode(code);
    handleCloseModal(); // Close the modal after confirming
    
  };

  const handleAddressDetails = () => {
    if (addressLine1 === "" || city === "" || state === "" || postalCode === "") {
      return toast.error("Address incomplete");
    }
    else {
      localStorage.setItem('buyer-address', JSON.stringify({
        addressLine1: addressLine1,
        addressLine2: addressLine2,
        city: city,
        state: state,
        postalCode: postalCode
      }));
      toast.success("Address edited successfully");
      navigate(-1);
    }
  }
  return (
    <>
      <div
        style={mobileView ? mobilestyle : style}
        className="form_main_container"
      >
        <p className="address_heading">Address</p>
        <Grid container spacing={2} className="address_form">
          <Grid item xs={12}>
            <FormControl fullWidth>
              <TextField
                label="Full Name"
                style={{ marginTop: "0px" }}
                InputLabelProps={{ shrink: true }}
                id="fullname"
                name="fullname"
                margin="normal"
                value={full_name}
              />
            </FormControl>
          </Grid>
          <Grid item xs={12}>
            <FormControl fullWidth>
              <TextField
                label="Address Line 1"
                style={{ marginTop: "0px" }}
                InputLabelProps={{ shrink: true }}
                id="addressLine1"
                name="addressLine1"
                margin="normal"
                value={addressLine1}
                onChange={(e) => {
                  setAddressLine1(e.target.value);
                }}
              />
            </FormControl>
          </Grid>
          <Grid item xs={12}>
            <FormControl fullWidth>
              <TextField
                label="Main Street Address Line 2"
                style={{ marginTop: "0px" }}
                InputLabelProps={{ shrink: true }}
                id="addressLine2"
                name="addressLine2"
                margin="normal"
                value={addressLine2}
                onChange={(e) => {
                  setAddressLine2(e.target.value);
                }}
              />
            </FormControl>
          </Grid>
          <Grid item xs={12}>
            <FormControl fullWidth>
              <TextField
                label="City"
                style={{ marginTop: "0px" }}
                InputLabelProps={{ shrink: true }}
                id="city"
                name="city"
                margin="normal"
                value={city}
                onChange={(e) => {
                  setCity(e.target.value);
                }}
              />
            </FormControl>
          </Grid>
          <Grid item xs={12}>
            <FormControl fullWidth>
              <TextField
                label="State"
                style={{ marginTop: "0px" }}
                InputLabelProps={{ shrink: true }}
                id="state"
                name="state"
                margin="normal"
                value={state}
                onChange={(e) => {
                  setState(e.target.value);
                }}
              />
            </FormControl>
          </Grid>
          <Grid item xs={12}>
            <FormControl fullWidth>
              <TextField
                label="Postal Code"
                style={{ marginTop: "0px" }}
                InputLabelProps={{ shrink: true }}
                id="zip"
                name="zip"
                margin="normal"
                value={postalCode}
                onChange={(e) => {
                  setPostalCode(e.target.value);
                }}
              />
            </FormControl>
          </Grid>

          {/* Confirmation button */}
          <Button
            className="marketplcae_botn"
            style={buttonStyle}
            variant="contained"
            color="primary"
            onClick={handleAddressDetails}
          >
            Confirm
          </Button>
        </Grid>
      </div>
    </>
  );
}

const style = {
  display: "flex",
  position: "relative",
  top: "5rem"
}
const mobilestyle = {
  display: "flex",
  position: "relative",
  top: "5rem"
  // flexDirection: "column"
}

export default AddressPage;
